export default {
  rttReferences: [],
  status: {}
};